// The prefix of the insert link placeholder
export const OWA_INSERT_LINK_PLACEHOLDER = 'OWA_Insert_Link_Placeholder_';
